import { connect } from 'react-redux';

import AwsSignupPage from './AwsSignupPage';
import { actionCreators } from '../../dux/user';

const mapDispatchToProps = {
  logInAWS: actionCreators.logInAWS,
};

export default connect(null, mapDispatchToProps)(AwsSignupPage);
